// LIST
export const FETCH_RESIDENCE = "app/Residence/FETCH_RESIDENCE";
export const FETCH_RESIDENCE_SUCCESS = "app/Residence/FETCH_RESIDENCE_SUCCESS";
export const FETCH_RESIDENCE_FAILURE = "app/Residence/FETCH_RESIDENCE_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/Residence/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Residence/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Residence/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_RESIDENCE = "app/Residence/ADD_RESIDENCE";
export const ADD_RESIDENCE_SUCCESS = "app/Residence/ADD_RESIDENCE_SUCCESS";
export const ADD_RESIDENCE_FAILURE = "app/Residence/ADD_RESIDENCE_FAILURE";
// EDIT
export const EDIT_RESIDENCE = "app/Residence/EDIT_RESIDENCE";
export const EDIT_RESIDENCE_SUCCESS = "app/Residence/EDIT_RESIDENCE_SUCCESS";
export const EDIT_RESIDENCE_FAILURE = "app/Residence/EDIT_RESIDENCE_FAILURE";
// DELETE
export const DELETE_RESIDENCE = "app/Residence/DELETE_RESIDENCE";
export const DELETE_RESIDENCE_SUCCESS =
  "app/Residence/DELETE_RESIDENCE_SUCCESS";
export const DELETE_RESIDENCE_FAILURE =
  "app/Residence/DELETE_RESIDENCE_FAILURE";
// DELETE NOTE
export const DELETE_RESIDENCE_NOTE = "app/Residence/DELETE_RESIDENCE_NOTE";
export const DELETE_RESIDENCE_NOTE_SUCCESS =
  "app/Residence/DELETE_RESIDENCE_NOTE_SUCCESS";
export const DELETE_RESIDENCE_NOTE_FAILURE =
  "app/Residence/DELETE_RESIDENCE_NOTE_FAILURE";
// DELETE RESIDENCE NOTE
export const DELETE_RESIDENCE_REMINDER_NOTE =
  "app/Residence/DELETE_RESIDENCE_REMINDER_NOTE";
export const DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS =
  "app/Residence/DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS";
export const DELETE_RESIDENCE_REMINDER_NOTE_FAILURE =
  "app/Residence/DELETE_RESIDENCE_REMINDER_NOTE_FAILURE";
//
export const OPEN_NOTE_ADD_MODAL = "app/Residence/OPEN_NOTE_ADD_MODAL";
export const CLOSE_NOTE_ADD_MODAL = "app/Residence/CLOSE_NOTE_ADD_MODAL";
//
export const OPEN_REMINDER_ADD_MODAL = "app/Residence/OPEN_REMINDER_ADD_MODAL";
export const CLOSE_REMINDER_ADD_MODAL =
  "app/Residence/CLOSE_REMINDER_ADD_MODAL";
//
export const OPEN_FAMILY_ADD_MODAL = "app/Residence/OPEN_FAMILY_ADD_MODAL";
export const CLOSE_FAMILY_ADD_MODAL = "app/Residence/CLOSE_FAMILY_ADD_MODAL";
// ADD
export const ADD_RESIDENCE_NOTE = "app/Residence/ADD_RESIDENCE_NOTE";
export const ADD_RESIDENCE_NOTE_SUCCESS =
  "app/Residence/ADD_RESIDENCE_NOTE_SUCCESS";
export const ADD_RESIDENCE_NOTE_FAILURE =
  "app/Residence/ADD_RESIDENCE_NOTE_FAILURE";
// LIST NOTES
export const FETCH_RESIDENCE_NOTES = "app/Residence/FETCH_RESIDENCE_NOTES";
export const FETCH_RESIDENCE_NOTES_SUCCESS =
  "app/Residence/FETCH_RESIDENCE_NOTES_SUCCESS";
export const FETCH_RESIDENCE_NOTES_FAILURE =
  "app/Residence/FETCH_RESIDENCE_NOTES_FAILURE";
// ADD RESIDENCE REMINDER
export const ADD_RESIDENCE_REMINDER = "app/Residence/ADD_RESIDENCE_REMINDER";
export const ADD_RESIDENCE_REMINDER_SUCCESS =
  "app/Residence/ADD_RESIDENCE_REMINDER_SUCCESS";
export const ADD_RESIDENCE_REMINDER_FAILURE =
  "app/Residence/ADD_RESIDENCE_REMINDER_FAILURE";
// LIST RESIDENCE NOTES
export const FETCH_RESIDENCE_REMINDERS =
  "app/Residence/FETCH_RESIDENCE_REMINDERS";
export const FETCH_RESIDENCE_REMINDERS_SUCCESS =
  "app/Residence/FETCH_RESIDENCE_REMINDERS_SUCCESS";
export const FETCH_RESIDENCE_REMINDERS_FAILURE =
  "app/Residence/FETCH_RESIDENCE_REMINDERS_FAILURE";
// ADD RESIDENCE FAMILY MEMBER
export const ADD_RESIDENCE_FAMILY_MEMBER =
  "app/Residence/ADD_RESIDENCE_FAMILY_MEMBER";
export const ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS =
  "app/Residence/ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS";
export const ADD_RESIDENCE_FAMILY_MEMBER_FAILURE =
  "app/Residence/ADD_RESIDENCE_FAMILY_MEMBER_FAILURE";
// EDIT RESIDENCE FAMILY MEMBER
export const EDIT_RESIDENCE_FAMILY_MEMBER =
  "app/Residence/EDIT_RESIDENCE_FAMILY_MEMBER";
export const EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS =
  "app/Residence/EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS";
export const EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE =
  "app/Residence/EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE";
// LIST RESIDENCE FAMILY MEMBERS
export const FETCH_RESIDENCE_FAMILY_MEMBERS =
  "app/Residence/FETCH_RESIDENCE_FAMILY_MEMBERS";
export const FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS =
  "app/Residence/FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS";
export const FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE =
  "app/Residence/FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE";
// GET FAMILY VIEW DATA
export const GET_FAMILY_VIEW_DATA = "app/Residence/GET_FAMILY_VIEW_DATA";
export const GET_FAMILY_VIEW_DATA_SUCCESS =
  "app/Residence/GET_FAMILY_VIEW_DATA_SUCCESS";
export const GET_FAMILY_VIEW_DATA_FAILURE =
  "app/Residence/GET_FAMILY_VIEW_DATA_FAILURE";
